import { type HTMLAttributes } from "react";
import { cn } from "./utils/cn";
import glyphUrl from "./assets/glyph.svg";

export type BrandMarkVariant = "glyph" | "full";
export type BrandMarkSize = "sm" | "md" | "lg" | "xl";

export interface BrandMarkProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BrandMarkVariant;
  size?: BrandMarkSize;
  /** Accessible label. Defaults to "Humaniti". */
  label?: string;
}

/**
 * Brand identity mark. Two variants:
 *
 * - `glyph` — just the ⓗ symbol (favicon contexts, compact menus).
 * - `full`  — glyph + Manrope wordmark + teal terminator dot. Composed from
 *   independent elements (NOT a single SVG) so the dot always sits as
 *   real punctuation immediately after the wordmark, regardless of font
 *   metrics or rendering size. Mirrors `brand-kit/.../ui_kits/website/Chrome.jsx`.
 */
export const BrandMark = ({
  variant = "glyph",
  size = "md",
  label = "Humaniti",
  className,
  ...rest
}: BrandMarkProps) => (
  <span
    className={cn("hui-brand-mark", `hui-brand-mark--${size}`, className)}
    aria-label={label}
    role="img"
    {...rest}
  >
    <img className="hui-brand-mark__glyph" src={glyphUrl} alt="" />
    {variant === "full" && (
      <span className="hui-brand-mark__wordmark" aria-hidden="true">
        humaniti<span className="hui-brand-mark__dot">.</span>
      </span>
    )}
  </span>
);
